jQuery.fn.extend({
	expandingSchedule: function (options = {}) {
		return this.each(function (expandingScheduleIndex) {
			var
				expandingScheduleID = 'expandingSchedule-' + +expandingScheduleIndex,
				$expandingSchedule = $(this).attr('id', expandingScheduleID),
				$times = $('.expanding-schedule-times > dl > dt', $expandingSchedule)
					.each(function (timeIndex) {
						$(this)
							.attr('id', expandingScheduleID + '-time-' + +timeIndex)
							.attr('aria-expanded', false)
							.attr('aria-controls', expandingScheduleID + '-description-' + +timeIndex)
							.next('.expanding-schedule-time-description')
								.attr('id', expandingScheduleID + '-description-' + +timeIndex)
								.attr('aria-labelledby', expandingScheduleID + '-time-' + +timeIndex)
								.attr('aria-hidden', true)
								.hide();

					}),
				$descriptions = $('.expanding-schedule-time-description', $expandingSchedule);

			$times
				.on('click keypress', function (event) {
					var
						$time = $(this),
						$description = $time.next('.expanding-schedule-time-description');

					if ('undefined' === typeof event.which || // onload
					    1 === event.which || // click
					    13 === event.which) { // enter
						$time.toggleClass(function () {
							var $this = $(this);

							$this.attr('aria-expanded', !$this.hasClass('active'));

							return 'active';
						});

						$description.slideToggle(function () {
							var $this = $(this);

							$this.attr('aria-hidden', $this.is(':hidden'));
						});

						$times.not($time)
							.removeClass('active')
							.attr('aria-expanded', false);
						$descriptions.not($description)
							.slideUp()
							.attr('aria-hidden', true);
					}
				})
				.first()
					.click();
		});
	}
});



// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.expandingSchedule.js